// eslint-disable-next-line jira/filename-case
import React from 'react';
import { HorizontalNavSkeleton } from '@jira/navigation-apps__horizontal-nav-common/src/ui/horizontal-nav-skeleton/index.tsx';
import { customPracticeQueueRoute } from '@jira/router-routes__servicedesk-queue-routes/src/customPracticeQueueRoute.tsx';
import { customIssueRoute } from '@jira/router-routes__servicedesk-queue-routes/src/customIssueRoute.tsx';
import { csmCustomIssueRoute } from '@jira/router-routes__servicedesk-queue-routes/src/csmCustomIssueRoute.tsx';
import { useCurrentRoute } from '@jira/platform__utils-router/src/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { useIsActiveRoute, usePathParam } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import { LazyHorizontalNavQueueForPaint } from './async-for-paint.tsx';

export const AsyncHorizontalNavQueue = (): false | React.JSX.Element => {
	const route = useCurrentRoute();
	const [issueKey] = usePathParam('issueKey');

	const isIssueViewOld =
		route.name === customIssueRoute.name ||
		(route.name === customPracticeQueueRoute.name && issueKey);

	const isIssueViewNext = useIsActiveRoute(
		new Set([customIssueRoute.name, customPracticeQueueRoute.name, csmCustomIssueRoute.name]),
	);

	const isIssueView = fg('csm_appification_standalone_navigation')
		? isIssueViewNext
		: isIssueViewOld;

	const content = !isIssueView && (
		<Placeholder name="horizontal-nav-queue" fallback={<HorizontalNavSkeleton />}>
			<LazyHorizontalNavQueueForPaint />
		</Placeholder>
	);

	return content;
};
